export default __webpack_public_path__ + "static/media/walletWhite.2ad75509.svg";